// extracted by css-extract-rspack-plugin
export default {"Box":"shared-issue-viewer-module__Box__hpaj6","Box_1":"shared-issue-viewer-module__Box_1__BXoVl"};